import { AnimatedContentLoader, Button, PaymentButton, ModalV2 } from '@components'
import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'
import styled from 'styled-components'
import { IPaymentDetails } from '@query'
import { HolviPaymentForm } from './components'
import {
  HolviPaymentsOnboarding,
  useShowHolviOnboarding
} from './components/HolviPaymentsOnboarding'

interface Props {
  isVisible: boolean
  onClose: () => void
  defaults?: Partial<IPaymentDetails>
  createPaymentFn: (data: IPaymentDetails) => Promise<IPaymentDetails>
}

export const HolviPaymentFormModal: React.FC<Props> = ({
  isVisible,
  onClose,
  defaults,
  createPaymentFn
}) => {
  const { t } = useTranslation()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { isLoading, showOnboarding } = useShowHolviOnboarding()

  return (
    <ModalV2
      isVisible={isVisible}
      header={
        showOnboarding
          ? t('containers.paymentFormModal.onboarding.title')
          : t('containers.paymentFormModal.title')
      }
      handleOnClose={onClose}
      width={500}
      height={showOnboarding ? 700 : 900}
      footer={
        <ButtonContainer>
          <Button type="button" onClick={onClose}>
            {t('general.cancel')}
          </Button>

          {!showOnboarding && (
            <PaymentButton
              showAmount={false}
              showSpinner={isSubmitting}
              disabled={isSubmitting}
              form="payment-form"
              type="submit"
              methods={[{ method: 'holvi' }]}
            />
          )}
        </ButtonContainer>
      }
    >
      <AnimatedContentLoader
        isLoading={isLoading}
        isEmpty={showOnboarding}
        isEmptyContent={<HolviPaymentsOnboarding />}
      >
        <HolviPaymentForm
          onSuccess={onClose}
          defaults={defaults}
          onSubmitStateChange={setIsSubmitting}
          createPaymentFn={createPaymentFn}
        />
      </AnimatedContentLoader>
    </ModalV2>
  )
}

const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.sm}rem;
  margin-top: ${({ theme }) => theme.spacing.md}rem;
`
